module.exports = __webpack_public_path__ + "static/media/vining_gimberling_soash_sweeney_thomas_stewart.59cf58ac.jpg";